const HEADER_OFFSET = 90;
const MOBILE_QUERY = "(max-width: 767px)"; // rwd.breakpoint(mobile)

$(document).ready(function () {
  const searchButton = $("#searchProjectsFilter");
  const projectSelect = document.getElementById("project_id"); // select Nr projektu
  const projectSelectTitle = document.getElementById("project_name"); // select tytuł projektu
  const projectType = document.getElementById("wbo_type"); // select zasięg projektu
  const projectStatus = document.getElementById("wbo_status"); // select status projektu
  const projectKind = document.getElementById("wbo_kind"); // select typ projektu
  const projectCategory = document.getElementById("wbo_kategoria"); // select kategoria projektu
  const projectSelectDistrict = document.getElementById("wbo_osiedle"); // select osiedle

  let globalFilters = {};
  let listItems = $("#listProjects").children();
  const itemsPerPage = 15;
  const paginationItemList = 4;
  const pagesCount = Math.max(Math.ceil($(listItems).length / itemsPerPage), 1);

  $("#listProjects").empty();
  $(".pagination")
    .find(".spacer")
    .after(
      `<li class="page-item" aria-hidden="true" id="${pagesCount}"><button class="page-link">${pagesCount}</button></li>`,
    );

  const firstLoadFilters = getFilters();
  // odczyt sesji
  let filterSession = sessionStorage.getItem("filter"); //pobieramy filtry z sesji
  let pageSession = sessionStorage.getItem("page"); // pobieramy numer strony z sesji
  $(".clearBtn").click(function (e) {
    globalFilters = firstLoadFilters;
    filterProjects(1);
    e.preventDefault();
    $(".formProjects")[0].reset();
    $(".select2Class").trigger("change");
    sessionStorage.removeItem("filter");
    sessionStorage.removeItem("page");

    $(".form__label").removeClass("shoLabel");
  });

  if (filterSession && pageSession) {
    if (filterSession.length > 0 && pageSession.length > 0) {
      // przekazujemy naszą zmienną którą pobraliśmy z sesji do funkcji filtrującej projekt
      globalFilters = JSON.parse(filterSession);
      filterProjects(pageSession);

      if (JSON.parse(filterSession).id) {
        $(projectSelect).val(JSON.parse(filterSession).id);
        $(projectSelect).trigger("change");
      }
      if (JSON.parse(filterSession).title) {
        $(projectSelectTitle).val(JSON.parse(filterSession).title);
        $(projectSelectTitle).trigger("change");
      }
      if (JSON.parse(filterSession).kind) {
        $(projectKind).val(JSON.parse(filterSession).kind);
      }
      if (JSON.parse(filterSession).category) {
        $(projectCategory).val(JSON.parse(filterSession).category);
      }
      if (JSON.parse(filterSession).type) {
        $(projectType).val(JSON.parse(filterSession).type);
      }
      if (JSON.parse(filterSession).status) {
        $(projectStatus).val(JSON.parse(filterSession).status);
      }
      if (JSON.parse(filterSession).district) {
        $(projectSelectDistrict).val(JSON.parse(filterSession).district);
        $(projectSelectDistrict).trigger("change");
      }
    }
  } else {
    if ($(firstLoadFilters).length > 0) {
      globalFilters = firstLoadFilters;
      filterProjects(1);
    } else {
      showPage(1, listItems);
    }
  }

  $(".pagination").click(function (e) {
    //3 Miko delegacja zdarzeń - z dzieci (li) na rodzica (ul) - wpływa na wydajność bo dodajesz 1 zdarzenie a nie osobno do każdego elementu
    let pageNum = "";
    const listItem = e.target;
    if (
      listItem.classList.contains("page-item[not:spacer]") ||
      listItem.classList.contains("page-link")
    ) {
      const listItemTxt = listItem.textContent;
      switch (
        listItemTxt /// Miko rozumiem że pod li z klasą spacer z 3 kropkami nic nie podpinamy - w Twoim kodzie po kliku w ... jest błąd NaN
      ) {
        case "»":
          pageNum = "next";
          break;
        default:
          pageNum = listItemTxt;
          sessionStorage.setItem("page", Number(pageNum));
          break;
      }
      // console.log( `element kliknięty - ${pageNum}` )
      filterProjects(pageNum); // Miko skoro globalFilters sa dostepne globalnie to nie ma sensu ich przekazywac
    }
  });

  searchButton.click(function (event) {
    event.preventDefault();
    globalFilters = getFilters();
    sessionStorage.setItem("page", 1);
    filterProjects(1);
    scrollAfterSearch();

    //TODO do zmiany w pozniejszym terminie inicjalizacja skryptu weather_tooltip_topBar
    $(document).ready(function () {
      // Kliknięcie w przycisk otwierający tooltip
      $("#listProjects [data-submit-tooltip]").on("click", function (e) {
        e.preventDefault();

        // Zamknięcie wszystkich otwartych tooltipów
        $("[data-content-tooltip]").hide().attr("aria-hidden", "true");
        $("[data-submit-tooltip]").attr("aria-expanded", "false");

        // Otwarcie wybranego tooltipa
        $(this)
          .next("[data-content-tooltip]")
          .show()
          .attr("aria-hidden", "false");
        $(this).attr("aria-expanded", "true");
      });

      // Kliknięcie w przycisk zamykający tooltip
      $("[data-close-tooltip]").on("click", function () {
        $(this)
          .closest("[data-content-tooltip]")
          .hide()
          .attr("aria-hidden", "true");
        $(this)
          .closest("[data-content-tooltip]")
          .prev("[data-submit-tooltip]")
          .attr("aria-expanded", "false");
      });
    });

    // po kliknięciu w szukaj projektów sprawdzamy czy jakiś filtr jest wybrany
    if (globalFilters !== {}) {
      // jeżeli jakiś filtr jest wybrany to przypisujemy do sesji ten właśnie filtr
      sessionStorage.setItem("filter", JSON.stringify(globalFilters));
    } else {
      // jeżeli nie ma żadnego filtru to oznacza że użytkownik chce wyświetlić całą stronę a więc usuwamy CAŁĄ SESJĘ
      sessionStorage.removeItem("filter");
      sessionStorage.removeItem("page");
    }
  });

  function scrollAfterSearch() {
    if (!window.matchMedia(MOBILE_QUERY).matches) return;

    const $project = getSelectedProject();

    scrollTo($project.length ? $project : $("[data-box-project-list]"));
  }

  // Kafelek projektu, którego nr wybrano w selekcie [data-list-project-id],
  // o ile taki data-id jest na wyrenderowanej liście.
  function getSelectedProject() {
    const selectedId = $("[data-list-project-id]").val();

    if (!selectedId) return $();

    return $("#listProjects").children(`[data-id="${selectedId}"]`);
  }

  function scrollTo($target) {
    if (!$target.length) return;

    $("html, body").animate(
      { scrollTop: $target.offset().top - HEADER_OFFSET },
      400,
    );
  }

  function paginate(pageNum, pagesCount, filter) {
    if (pageNum !== "next") {
      paginationAction(pageNum, pagesCount, filter);
    } else if (pageNum === "next") {
      const activeBefore = parseInt(
        $(".pagination").find(".active ").first().text(),
        10,
      );
      paginationAction(activeBefore + 1, pagesCount, filter);
    }
  }

  function showPage(pageNum, filter) {
    let projectWord;
    if (filter.length !== 0) {
      if (filter.length == 1) {
        projectWord = projectWord1;
      } else if (
        filter.length == 2 ||
        filter.length == 3 ||
        filter.length == 4
      ) {
        projectWord = projectWord2;
      } else {
        projectWord = projectWord3;
      }
      $(".boxProjectListHeaderCover").find(".projecstCountBar").remove();

      if ($(window).width() > 768) {
        $(".boxProjectListHeaderCover")
          .after()
          .append(
            '<span class="projecstCountBar" aria-atomic="true" aria-live="polite">(' +
              filter.length +
              " " +
              projectWord +
              ")</span>",
          );
      } else if ($(window).width() < 767) {
        $(".boxProjectListHeaderCover .boxPagerTop")
          .after()
          .append(
            '<span class="projecstCountBar" aria-atomic="true" aria-live="polite">(' +
              filter.length +
              " " +
              projectWord +
              ")</span>",
          );
      }
    } else {
      $(".boxProjectListHeaderCover").find(".projecstCountBar").remove();
    }
    $("#listProjects").empty();
    for (
      let i = (pageNum - 1) * itemsPerPage;
      i < pageNum * itemsPerPage;
      i++
    ) {
      $("#listProjects").append($(filter[i]));
    }
    $(".pagination li").removeClass("active");
    $(".pagination")
      .find("#" + pageNum)
      .addClass("active");

    if (typeof classCart !== "undefined") classCart.refreshButtons();
  }

  function makePagination(numbers) {
    $(".pagination li").remove();

    for (let i = 0; i < numbers.length; i++) {
      const value = String(numbers[i]);
      if (numbers.length === 1 && numbers[0] === "1-active") {
      } else if (String(value).split("-")[1] === "active") {
        $(".pagination").append(
          `<li class="page-item" aria-hidden="true" id="${value.split("-")[0]}"><button class="page-link">${value.split("-")[0]}</button></li>`,
        );
      } else if (numbers[i] === "") {
        $(".pagination").append(
          `<li class="page-item spacer" aria-hidden="true" >...</li>`,
        );
      } else if (numbers[i] === "next") {
        $(".pagination").append(
          `<li class="page-item next" aria-hidden="true" ><button class="page-link">»</button></li>`,
        );
      } else {
        $(".pagination").append(
          `<li class="page-item" aria-hidden="true" id="${value}"><button class="page-link">${value}</button></li>`,
        );
      }
    }
  }

  function paginationAction(pageNum, pagesCount, filter) {
    pageNum = Math.min(Math.max(parseInt(pageNum, 10) || 1, 1), pagesCount);

    const pages = [];
    const active = pageNum + "-active";

    if (pagesCount <= paginationItemList + 1) {
      for (let i = 1; i <= pagesCount; i++) {
        pages.push(i === pageNum ? active : i);
      }
    } else if (pageNum < paginationItemList) {
      for (let i = 1; i <= paginationItemList; i++) {
        pages.push(i === pageNum ? active : i);
      }
      pages.push("", pagesCount);
    } else {
      pages.push(1);
      if (pageNum - 1 > 2) pages.push("");
      for (let i = pageNum - 1; i <= Math.min(pageNum + 1, pagesCount); i++) {
        pages.push(i === pageNum ? active : i);
      }
      if (pageNum + 2 < pagesCount) pages.push("");
      if (pageNum + 1 < pagesCount) pages.push(pagesCount);
    }

    if (pageNum < pagesCount) pages.push("next");

    makePagination(pages);
    showPage(pageNum, filter);
  }

  function filterProjects(pagenum) {
    let filteredCount = 0;
    const filteredListItems = [];
    $(listItems).each(function (index) {
      const filterMatch = compareArrays(globalFilters, $(this).data());
      if (filterMatch === true) {
        filteredCount++;
        filteredListItems[filteredCount - 1] = $(this)[0]; // Zmieniamy indeks o jeden wstecz
      }
    });

    const pagesCount = Math.max(Math.ceil(filteredCount / itemsPerPage), 1);

    if (globalFilters !== {}) {
      paginate(pagenum, pagesCount, filteredListItems);

      if (filteredListItems.length === 0) {
        $(".boxNoResult").removeClass("hidden");
        $(".boxPager").addClass("hidden");
      } else {
        $(".boxNoResult").addClass("hidden");
        $(".boxPager").removeClass("hidden");
      }
    } else {
      paginate(pagenum, pagesCount, listItems);
    }
  }

  function compareArrays(array1, array2) {
    for (const key in array1) {
      if (!(key in array2)) {
        return false;
      }

      const filtersValue = array1[key];
      const projectValue = array2[key];

      if (key === "district" || key === "category") {
        const filterValuesArray = String(filtersValue)
          .split(",")
          .map((value) => value.trim());
        const projectValuesArray = String(projectValue)
          .split(",")
          .map((value) => value.trim());

        // Sprawdź, czy przynajmniej jedna wartość z filterValuesArray jest zawarta w projectValuesArray
        const match = filterValuesArray.some((value) =>
          projectValuesArray.includes(value),
        );

        if (!match) {
          return false;
        }
      } else if (filtersValue !== projectValue) {
        return false;
      }
    }
    return true;
  }

  function getFilters() {
    let projectCategoryFilter = "";
    let projectStatusFilter = "";
    let projectSelectFilter = "";
    if ($(projectSelect).find(":selected").val()) {
      projectSelectFilter = parseInt($(projectSelect).find(":selected").val());
    }
    if ($(projectCategory).val()) {
      projectCategoryFilter = parseInt($(projectCategory).val());
    }
    if ($(projectStatus).val()) {
      projectStatusFilter = parseInt($(projectStatus).val());
    }
    let filtersTable = {
      id: projectSelectFilter || $(projectSelectTitle).find(":selected").val(),
      district: $(projectSelectDistrict).find(":selected").val(),
      kind: $(projectKind).val(),
      category: projectCategoryFilter,
      type: $(projectType).val(),
      // 'status': $(projectStatus).val(),
      status: projectStatusFilter,
    };
    $.map(filtersTable, function (val, i) {
      if (val === "" || val === null || val === undefined) {
        delete filtersTable[i];
      }
    });

    return filtersTable;
  }
  /* TODO DO WYCZYSCZENIA - KOD DODAJE ŁABELKI NA MOBILKACH PO KLIKNIĘCIU< ALE TO ZOSTAŁO OGRANE W CSS
    if ($(window).width() < 768) {
        // dodaje wsplywajace label po click na select2 na mobilkach
        $(projectSelect).on('select2:select', function (e) {
            // label Nr projektu    
            if ($(projectSelect).find(':selected').val()) {
                $(projectSelect).siblings('.form__label').addClass('shoLabel');
            } else {
                $(projectSelect).siblings('.form__label').removeClass('shoLabel');
            }
        });

        $(projectSelectTitle).on('select2:select', function (e) {
            // label Tytul projektu
            if ($(projectSelectTitle).find(':selected').val()) {
                $(projectSelectTitle).siblings('.form__label').addClass('shoLabel');
            } else {
                $(projectSelectTitle).siblings('.form__label').removeClass('shoLabel');
            }
        });

        $(projectSelectDistrict).on('select2:select', function (e) {
            // label osiedleprojektu
            if ($(projectSelectDistrict).find(':selected').val()) {
                $(projectSelectDistrict).siblings('.form__label').addClass('shoLabel');
            } else {
                $(projectSelectDistrict).siblings('.form__label').removeClass('shoLabel');
            }
        });

        // dodaje wsplywajace label po click na select na mobilkach
        $('.formProjects .form-group select').click(function (event) {

            // label Zasięg projektu
            if ($(projectType).val()) {
                $(projectType).siblings('.form__label').addClass('shoLabel');
            } else {
                $(projectType).siblings('.form__label').removeClass('shoLabel');
            }

            // label Status projektu
            if ($(projectStatus).val()) {
                $(projectStatus).siblings('.form__label').addClass('shoLabel');
            } else {
                $(projectStatus).siblings('.form__label').removeClass('shoLabel');
            }

            // label Typ projektu
            if ($(projectKind).val()) {
                $(projectKind).siblings('.form__label').addClass('shoLabel');
            } else {
                $(projectKind).siblings('.form__label').removeClass('shoLabel');
            }

            // label kategoria projektu
            if ($(projectCategory).val()) {
                $(projectCategory).siblings('.form__label').addClass('shoLabel');
            } else {
                $(projectCategory).siblings('.form__label').removeClass('shoLabel');
            }

        });
    } else {
        $('.form__label').removeClass('shoLabel');
    } */
});

// na mobilkach po kliknienciu pokazuje listę filtrów
$(document).ready(function () {
  $(".lnkMobileCart").click(function (e) {
    e.preventDefault();
    $(".wrapperCart").addClass("isVisible");
  });

  $(".lnkCloseCart").click(function (e) {
    e.preventDefault();
    $(".wrapperCart").removeClass("isVisible");
  });

  $(".lnkShowFilters").click(function (e) {
    e.preventDefault();

    const $link = $(this);
    const $filters = $(".formProjects .boxMobileHidden");

    if ($link.hasClass("isExpanded")) {
      $filters.slideUp(500);
      $link.removeClass("isExpanded").text($link.data("show-text"));
    } else {
      $filters.slideDown(500);
      $link.addClass("isExpanded").text($link.data("hide-text"));
    }
  });
});
